import axios from 'axios';
import { clearAccessToken, getAccessToken } from './accessToken';

export const API_URL = process.env.REACT_APP_API_URL || 'https://api.avito.chat.innoprog.ru';
export const SESSION_INVALID_EVENT = 'innoprog-avito-session-invalid';

export const apiClient = axios.create({
  baseURL: API_URL,
  timeout: 20000,
  withCredentials: true,
});

apiClient.interceptors.request.use((config) => {
  const token = getAccessToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

apiClient.interceptors.response.use(undefined, (error) => {
  const sessionInvalid = error.response?.status === 401
    || (error.response?.status === 403
      && error.response?.data?.detail === 'Avito chats are available only to administrators');
  if (sessionInvalid) {
    clearAccessToken();
    localStorage.removeItem('accessToken');
    localStorage.removeItem('currentUser');
    window.dispatchEvent(new Event(SESSION_INVALID_EVENT));
  }
  return Promise.reject(error);
});
